import React from "react";
import { Star, Quote, ExternalLink } from "lucide-react";

// NOTE: Placeholder testimonials only. Replace with real, verified customer
// reviews once collected. Fictional names, not authentic testimonials.
const REVIEWS = [
  { name: "James R.",   area: "Calgary",     text: "Booked online in the morning, tires swapped in my driveway by lunch. Professional, tidy, and honestly priced." },
  { name: "Sarah M.",   area: "Airdrie",     text: "Flat tire in the office parking lot — Mavtech was there in under an hour. Absolute lifesaver." },
  { name: "Michael T.", area: "Cochrane",    text: "Best decision skipping the tire shop. Balanced perfectly, no vibration. Would recommend to anyone." },
  { name: "Priya S.",   area: "Chestermere", text: "Friendly technician, explained everything clearly, and the price matched the quote exactly." },
  { name: "David L.",   area: "Okotoks",     text: "Seasonal changeover done in my garage while I worked from home. Zero disruption." },
  { name: "Amanda K.",  area: "Calgary NW",  text: "Small fleet of vans, all done same day. Mavtech has become our go-to for tire service." },
];

export const Reviews = () => (
  <section id="reviews" className="section-mv bg-brand-surface">
    <div className="container-mv">
      <div className="max-w-2xl">
        <div className="text-xs font-semibold tracking-widest text-brand-red uppercase">Customer Reviews</div>
        <h2 className="mt-3 font-display font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-brand-black">
          What our customers <span className="text-brand-red">are saying.</span>
        </h2>
      </div>

      <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {REVIEWS.map((r, i) => (
          <div key={r.name + i} className="relative rounded-xl bg-white border border-neutral-200 p-8 shadow-premium hover:shadow-premium-hover transition-shadow">
            <Quote className="absolute top-6 right-6 w-6 h-6 text-brand-red/20" />
            <div className="flex items-center gap-1">
              {Array.from({ length: 5 }).map((_, k) => (
                <Star key={k} className="w-4 h-4 fill-brand-red text-brand-red" />
              ))}
            </div>
            <p className="mt-4 text-neutral-800 leading-relaxed text-[15px]">"{r.text}"</p>
            <div className="mt-6 flex items-center gap-3 pt-5 border-t border-neutral-100">
              <div className="w-9 h-9 rounded-full bg-brand-black text-white flex items-center justify-center text-sm font-display font-bold">
                {r.name[0]}
              </div>
              <div>
                <div className="font-semibold text-sm text-brand-black">{r.name}</div>
                <div className="text-xs text-neutral-500">{r.area}</div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Google Review CTA — placeholder link, update when Google Business Profile is live */}
      <ReviewCTA />
    </div>
  </section>
);

// Update GOOGLE_REVIEW_URL below once the Google Business Profile is live:
// https://search.google.com/local/writereview?placeid=YOUR_PLACE_ID
const GOOGLE_REVIEW_URL = "https://www.google.com/search?q=mavtech+mobile+tires+calgary";

const GoogleGIcon = () => (
  <svg viewBox="0 0 48 48" className="w-5 h-5" aria-hidden="true">
    <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
    <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
    <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
    <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
  </svg>
);

const ReviewCTA = () => (
  <div className="mt-14 rounded-2xl bg-brand-black text-white p-8 sm:p-10 flex flex-col md:flex-row items-start md:items-center gap-6 justify-between overflow-hidden">
    <div className="flex items-start gap-5">
      <div className="w-12 h-12 rounded-xl bg-white flex items-center justify-center shrink-0">
        <GoogleGIcon />
      </div>
      <div>
        <h3 className="font-display font-bold text-2xl sm:text-3xl tracking-tight">
          Loved the service? <span className="text-brand-red">Tell Google.</span>
        </h3>
        <p className="mt-2 text-white/70 text-sm max-w-lg">
          A quick 5-star review on Google helps more Calgary drivers find us — and lets us keep our pricing honest.
        </p>
      </div>
    </div>
    <a
      href={GOOGLE_REVIEW_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="google-review-cta"
      className="shrink-0 inline-flex items-center gap-2 rounded-full bg-brand-red text-white px-6 py-3 text-sm font-semibold hover:bg-[#CC0000] active:scale-95 transition-all shadow-md shadow-red-500/30"
    >
      Leave a Google Review <ExternalLink className="w-4 h-4" />
    </a>
  </div>
);

export default Reviews;
